import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet';
import Header from '../../../../Components/Header';
import Footer from '../../../../Components/Footer';
import 'slick-carousel/slick/slick.css';
import SVGCurveLine from '../../../../Hooks/SVGCurveLine'; 
import { IoArrowBackCircleOutline } from "react-icons/io5";
import logo from "../../../../Assets/Images/logos/work/energy/apollo-energy.png"
import CaseStudyNav from '../../../../Components/KeywordCaseStudyNav';

const FromLowVisibilityToIndustryAuthorityForApolloEnergyAnalytics = () => {
  return (
    <>
    <Helmet>
<title>From Low Visibility to Industry Authority: Apollo Energy</title>
<link rel="canonical" href="https://www.agency09.in/work/case-studies/apollo-energy-analytics-seo-authority"/>
<meta name="robots" content="index, follow"/> 

<meta name="description" content="Apollo Energy Analytics saw massive gains in domain authority, rankings, and organic traffic through focused SEO for the U.S. renewable energy SaaS market."/>
<meta property="og:title" content="From Low Visibility to Industry Authority: Apollo Energy"/> 
<meta property="og:description" content="Apollo Energy Analytics saw massive gains in domain authority, rankings, and organic traffic through focused SEO for the U.S. renewable energy SaaS market."/> 
<meta property="og:image" content="https://www.agency09.in/agency09.png"/> 
<meta property="og:type" content="website"/> 


<meta name="twitter:card" content="summary"/> 
<meta name="twitter:site" content="@AGENCY09"/> 
<meta name="twitter:creator" content="@AGENCY09"/> 
<meta name="twitter:url" content="https://www.agency09.in/work/case-studies/apollo-energy-analytics-seo-authority"/> 
<meta name="twitter:description" content="Apollo Energy Analytics saw massive gains in domain authority, rankings, and organic traffic through focused SEO for the U.S. renewable energy SaaS market."/> 
<meta name="twitter:image" content="https://www.agency09.in/agency09.png"/> 

</Helmet>
    <Header/>
    <div className="spacer"></div>


    <section className='cSsecMin'>
        <div className='container'>
            
            <div className='cSsecMinA flexBio'>

                <div className='cSsecMinBtn m0'>
                <Link to='/work/case-studies' className='backBtn'><span><IoArrowBackCircleOutline /> Case Study</span></Link>
                </div>

                <div className='cSsecMinHead m0'>
                    <h1 className='sizeH4'>From Low Visibility to Industry Authority: Apollo Energy Analytics</h1>
                </div>

                <div className='cSsecMinInfo m0'>
                    <img src={logo} loading='lazy' />
                    {/* <Link>Info <GoPlus /></Link> */}
                </div>

            </div>

            <div className='strokeB'>
                <SVGCurveLine/>
            </div>  


            <div className='cSsecMinB'>
                <div className='cSsecMinBRow'>
                    <div className='cSsecMinBCol'>
                        <h4>Overview</h4>
                        <p>Apollo Energy Analytics, a cutting-edge SaaS platform for renewable energy assets, partnered with us to enhance its online visibility, boost qualified traffic, and fix critical technical and analytics issues. Through targeted SEO and website optimization strategies, Apollo significantly improved domain authority, keyword rankings, and lead-generating traffic positioning itself as a key player in the U.S. renewable energy SaaS market.
</p>
                    </div>

                    <div className='cSsecMinBCol'>
                        <h4>Industry</h4>
                        <p> Services for Renewable Energy</p>
                    </div>
                    
                    <div className='cSsecMinBCol'>
                        <h4>Services</h4>
                       <p> Website & SEO</p>
                    </div>
                    
                    <div className='cSsecMinBCol'>
                    <h4>Year </h4>
                    <p>Dec 22 - Nov 24</p>
                    </div>

                    <div className='cSsecMinBCol'>
                        <h4>Objective</h4>
                        <ul>
                            <li>Boost Organic Traffic by 41.32%</li>
                            <li>Improve Keyword Rankings</li>
                            <li>Expand U.S. Market Reach</li>
                            <li>Drive Quality Leads</li>
                        </ul>
                    </div>

                    <div className='cSsecMinBCol'>
                        <h4>Challenges</h4>
                        <ul>
                            <li>Low Organic Visibility</li>
                            <li>Optimize content and site structure </li>
                            <li>Technical SEO Issues</li>
                            <li> The site lacked optimization for the competitive U.S. renewable energy market</li>
                            <li>Incomplete Google Analytics tracking setup </li>
                            <li>Low Domain Authority</li>
                            <li>Tough Competition in renewable energy analytics market</li>
                        </ul>
                    </div>

                    <div className='cSsecMinBCol cSsecMinBColS2'>
                        <h4>Results</h4>
                        <ul>
                            <li><b>146.67% Increased:</b> Domain Authority</li>
                            <li><b>40% Increased:</b> Page Authority</li>
                            <li><b>60% Increased:</b> Indexed Pages</li>
                            <li><b>269.05% Increased:</b> Organic Sessions</li>
                            <li><b>275.11% Increased:</b> Overall Sessions</li>
                            <li><b>35.71% Increased:</b> Keywords Indexed</li>
                        </ul>
                    </div>

                </div>

            </div>


        </div>
    </section>
<CaseStudyNav/>

    <Footer/>
    </>
  )
}

export default FromLowVisibilityToIndustryAuthorityForApolloEnergyAnalytics
